<template>
  <v-menu bottom offset-y class="room-actions-nav__dropdown--wrap">
    <template v-slot:activator="{ on }">
      <v-btn
        color="secondary"
        v-on="on"
        class="room-actions-nav__dropdown-btn mr-2"
      >
        <content-line text="Actions" icon="campaigns/all" />
        <v-icon class="pr-2" color="appMain">expand_more</v-icon>
      </v-btn>
    </template>

    <div class="room-actions-nav room-actions-nav__dropdown">
      <div class="room-actions-nav__header">
        Actions for
        <strong>{{ getDefaultTitle() }}</strong
        >:
      </div>
      <content-line
        v-for="action in actionsMenuItems"
        :key="action.type"
        class="room-actions-nav__item"
        :text="action.title"
        :icon="action.icon"
        @click.native="selectAction(action)"
      />
    </div>
  </v-menu>
</template>

<script>
import { eventBus } from '@/lib/events';
import { mapState } from 'vuex';

export default {
  name: 'ActionsNav',
  props: {
    actionsMenuItems: {
      type: Array,
      default: () => [],
    },
    selectedParticipantsCount: {},
    group: {},
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
  },
  methods: {
    async selectAction(action) {
      const { group_only, type, dialog } = action;
      // create new group for selected participants before action
      if (this.selectedParticipantsCount && group_only) {
        const groupAction = this.actionsMenuItems.find(({ type }) => {
          return type === 'ActionGroup';
        });
        eventBus.trigger('selectAction', groupAction);
        await this.$nextTick();
      }

      if (type === 'ActionOpenAssignmentBoard') {
        this.openAssignmentBoard();
        return;
      }

      if (type !== 'ActionInvites') {
        eventBus.trigger('clearActionsContexts');
      }

      action.api.select();
    },

    openAssignmentBoard() {
      const { identity, room, room_name } = this.roomInfo;
      const data = {
        name: 'room-board',
        query: {
          hostId: identity,
          room,
          room_name,
        },
      };

      const route = this.$router.resolve(data);
      window.open(route.href, '_blank');
    },

    getDefaultTitle() {
      const selectedCount = this.selectedParticipantsCount;
      if (selectedCount) return selectedCount;
      return !this.group || this.group.id === 'all' ? 'Everyone' : 'Group';
    },
  },
};
</script>

<style lang="less">
.room-actions-nav {
  height: 100%;
  max-width: 280px;
  width: 100%;
  box-shadow: @content-shadow;
  background-color: #fff;
  z-index: 1;
  overflow: auto;

  &__dropdown {
    max-height: calc(100vh - 40px);
    margin-top: 5px;
  }

  &__header {
    padding: 8px 16px;
    border-bottom: 2px solid #ccc;
    font-size: 16px;
    font-weight: bold;
  }

  &:not(.room-actions-nav__dropdown) {
    position: absolute;
    top: 0;
  }

  &__dropdown-btn {
    padding: 0 !important;
    max-width: 200px;

    .v-btn__content {
      max-width: 100%;
    }

    .content-line {
      height: auto;
      padding: 0 4px 0 4px;
      background: none;

      .content-line__text {
        font-size: 14px;
        padding-left: 0;
      }
    }
  }
}

.room-actions-nav__item {
  border-bottom: 1px solid var(--v-borderColor-base);
  cursor: pointer;

  &.active,
  &:hover {
    background-color: var(--v-lightGray-base);
  }
}
</style>
